module.exports = __webpack_public_path__ + "img/about-02.62ee196b.png";